export default __webpack_public_path__ + "static/media/Ballroll_00032.52243d7f.png";